import React from 'react';
import { useParams } from 'react-router';
import { Container, Grid } from '@material-ui/core';
import ClientEditSidebar, {
    ACTIVE_CLIENT_SIDEBAR_TAB_NAMES
} from '../clientedit/ClientEditSidebar';
import PaymentMethodEditForm from './components/PaymentMethodEditForm';

function ClientPaymentMethodEditPage() {
    const { clientId, methodId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.paymentmethods} />
                <Grid className="pageContent">
                    <PaymentMethodEditForm clientId={clientId} methodId={methodId} />
                </Grid>
            </Grid>
        </Container>
    );
}

export default ClientPaymentMethodEditPage;
